import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import {  Routes ,Route } from 'react-router-dom';
import { useEffect } from 'react';
import {messaging} from './firebase'
import {getToken} from 'firebase/messaging'

import MainHome from './homepage/MainHome'
import SearchPage from './homepage/SearchPage'
import LoginPage from './login/LoginPage'
function App() {

  const requestionNotification = async ()=>{
    const premission = await Notification.requestPermission();
    console.log('premission ',premission);
    if(premission === "granted"){
      localStorage.setItem('notificationpremission', premission);
      const token = await getToken(messaging,{vapiKey:'BBLnWPXrfXEwOAlSCEnjEH6VbYIVztfIr1gUbM55blbCYkXulW0ld5T4Xguh9-fbEjzmDWVuIEdMeKUmgIy4680'});
      console.log(token);
      localStorage.setItem('browsertoken', token);
    }
  }
  useEffect(()=>{
    requestionNotification();

  },[])
  return (
    <div className="App">
    <Routes>
      <Route path='/'Component={MainHome} />
      <Route path='/login' Component={LoginPage} />
      <Route path='/search'Component={SearchPage} />
    </Routes>
    </div>
  );
}

export default App;
